import { css } from '@emotion/react';
import { Box, Flex, Stack, Text, Title, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { Trans, useTranslation } from 'next-i18next';

import { NEXT_PUBLIC_CDN_URL } from '../../../../appConfig';
import StartInstructorButton from './StartInstructorButton';
import { JOIN_INSTRUCTOR_SPOTS } from './constants/gtmEventParams';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <Box component="section" css={styleSection}>
      <Flex direction="column" align="center" gap={48} css={styleContainer}>
        <Stack spacing={16} css={styleTextStack}>
          <Text color="gray.9" css={styleHeading}>
            <Trans
              i18nKey="open.knowledge.hero.heading"
              components={{
                green: <span css={styleGreenText} />,
                br: <br />,
              }}
            />
          </Text>
          <Box css={styleSubText}>
            <Title order={3} weight={700} color="dark.9" css={styleSubBold}>
              {t('open.knowledge.hero.subtitle')}
            </Title>
            <Text color="gray.9" css={styleSubNormal}>
              {t('open.knowledge.hero.description')}
            </Text>
          </Box>
        </Stack>
        <StartInstructorButton
          spot={JOIN_INSTRUCTOR_SPOTS.HERO}
          variant="filled"
          color="dark"
          miw={260}
          h={56}
        >
          {t('open.knowledge.cta.start')}
        </StartInstructorButton>
      </Flex>
    </Box>
  );
};

export default HeroSection;

const styleSection = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  paddingTop: 200,
  paddingBottom: 200,
  backgroundImage: `url("${NEXT_PUBLIC_CDN_URL}/assets/images/open-knowledge/title_bg_lg.png")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  [desktopFirstMediaQuery.tablet]: {
    paddingTop: 160,
    paddingBottom: 160,
  },
  [desktopFirstMediaQuery.mobile]: {
    backgroundImage: `url("${NEXT_PUBLIC_CDN_URL}/assets/images/open-knowledge/title_bg_sm.png")`,
    paddingTop: 120,
    paddingBottom: 120,
  },
});

const styleContainer = css({
  position: 'relative',
  maxWidth: 1200,
  width: '100%',
  padding: '0 32px',
  [desktopFirstMediaQuery.mobile]: {
    padding: '0 16px',
  },
});

const styleTextStack = css({
  width: '100%',
  textAlign: 'center',
});

const styleHeading = css({
  fontSize: 56,
  fontWeight: 700,
  lineHeight: 1.3,
  [desktopFirstMediaQuery.tablet]: {
    fontSize: 44,
  },
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 28,
  },
});

const styleGreenText = css({
  color: '#00a760',
});

const styleSubText = css({
  textAlign: 'center',
  fontSize: 22,
  lineHeight: 1.5,
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 18,
  },
});

const styleSubBold = css({
  fontWeight: 700,
  fontSize: 22,
  lineHeight: 1.5,
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 18,
  },
});

const styleSubNormal = css({
  fontWeight: 400,
  fontSize: 22,
  lineHeight: 1.5,
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 18,
  },
});
